import { userConstants } from '../constants';

export function users(state = {}, action) {
  switch (action.type) {
    case userConstants.GETACCOUNT_SUCCESS:
      return {
        account: action.account
      };
    case userConstants.EDITACCOUNT_SETUP:
      return {
        ...state,
        edit: state.account ? {
          adresse: state.account.adresse,
          cp: state.account.cp,
          dateNaissance: state.account.dateNaissance,
          email: state.account.email,
          nom: state.account.nom,
          prenom: state.account.prenom,
          telephone: state.account.telephone,
          ville: state.account.ville
        } : null
      };
    case userConstants.EDITACCOUNT_SET:
      return {
        ...state,
        edit: action.account
      }
    case userConstants.PATCHACCOUNT_SUCCESS:
      return {
        account: action.account
      };
    default:
      return state
  }
}